import axios from "axios";

export default {
  getOrgs(page = 0, count = 10, search) {
    const body = {
      page: page,
      count: count,
      search: {
        text: search,
      },
    };
    return axios.post("/efficiency/OrganizationProfile", body);
  },

  getOrgsWithoutParams(model) {
    return axios.post("/efficiency/OrganizationProfile", model);
  },

  getDicts(request, config) {
    return axios.post("/nsi/SystemDictionary", request, config);
  },

  getDevicesByOrg(orgProfileId, page, count, filterItems) {
    const data = {
      page,
      count,
      filterItems,
    };

    return axios.post(
      `/efficiency/OrganizationProfile/${orgProfileId}/MeteringDevices`,
      data,
    );
  },
  getOrganizationById(id) {
    return axios.get(`/efficiency/OrganizationProfile/BaseInfo?orgId=${id}`);
  },

  deleteDevice(id, orgProfileId) {
    return axios.delete(
      `/efficiency/OrganizationProfile/${orgProfileId}/MeteringDevice/${id}`,
    );
  },
};
